module.exports = __webpack_public_path__ + "static/media/smileBig.61ebb85f.svg";